import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Law = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M39.99 32.592c.1-.2 1.698-5.297 1.798-5.497l2-6.096c.599-1.9-.1-3.998-1.7-5.197L24.798 3.209c-1.599-1.2-3.897-1.2-5.496 0L1.912 15.802C.312 17-.387 19.1.212 20.999l2 6.196c.2.7 1.799 5.697 2.098 6.196 2.2 5.097 8.495 8.296 15.291 8.296H24.4c6.796 0 12.992-3.199 15.29-8.296.1-.2.2-.6.3-.8Zm-15.591 7.196H19.6c-5.796 0-10.893-2.599-12.992-6.297h30.882c-2.199 3.598-7.196 6.297-13.092 6.297Zm13.892-8.295H5.71l-1.1-3.498h34.88l-1.2 3.497Zm3.697-11.794c0 .2-.1.4-.1.7l-1.799 5.597H3.911l-1.8-5.597c-.4-1.1 0-2.299 1-2.998l17.29-12.593.6-.3c.8-.3 1.798-.2 2.598.3l17.29 12.593c.8.5 1.2 1.399 1.1 2.298Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M28.396 15.702 25.698 17.9l.9 3.299c.3.999-.8 1.798-1.7 1.299l-2.898-2-2.898 1.9c-.9.5-2-.3-1.7-1.3l.9-3.297-2.698-2.2c-.4-.299-.5-.899-.4-1.299.1-.4.5-.799 1.1-.799l3.397-.2 1.2-3.198c.4-1 1.799-1 2.198 0l1.2 3.198 3.398.2c.6 0 .9.4 1.099.8.1.5 0 .999-.4 1.399Z"
  })));
});
Law.displayName = 'Law';
Law.defaultProps = {
  'aria-label': 'Law'
};
export default Law;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Law.js
// module id = 3654
// module chunks = 11